import { FC, useMemo } from "react";
import { TestIcon } from "routes/analysis/helpers/analysisHelpers";
import { RuleFunction, UserListData } from "routes/analysis/types/analysis";
import UserStatistics from "components/common/userStatistics";
import { parseStats } from "../helpers/helpers";

const TestInfo: FC<{ userList: UserListData }> = ({ userList }) => {
  const stats = useMemo(() => parseStats(userList), [userList]);
  return (
    <>
      <h1>Test</h1>
      <div className="ap-list-header ap-business-process-header flex items-center p-5 gap-4">
        <div className="basis-96">Test</div>
        <div className="basis-20">Test type</div>
        <div className="basis-72">Function(s) included in Test</div>
        <div className="grow">Distinct user matches</div>
      </div>
      <div className="list-row-1 flex items-center p-5 gap-4 mb-4">
        <div className="basis-96">
          <b>{userList?.test?.identifier}</b>
          <p>{userList.test?.functions?.map(m => <span key={userList.testId?.concat(":").concat(m.functionId)} className="ap-function-description">{m.description}</span>)}</p>
        </div>
        <div className="basis-20">
          <TestIcon type={userList.test?.type || "SA"} />
        </div>
        <div className="basis-72">
          {userList.test?.functions?.map((f: RuleFunction) => (
            <div key={f.functionId}>
              <b>{f.identifier}</b>
              <p>{f.description}</p>
            </div>
          ))}
        </div>
        <div className="grow">
          <UserStatistics stats={stats} />
        </div>
      </div>
    </>
  );
};

export default TestInfo;
